import { Button } from 'react-bootstrap';

export type PagerProps = React.PropsWithChildren<{
  pagesSize?: number;
  currentPage?: number;
  onPageChange: (currPage: number) => void;
}>;

const Pager = ({ onPageChange, pagesSize = 1, currentPage }: PagerProps) => {
  const handlePageChange = (idx: number) => {
    onPageChange(idx);
  };

  const handlePageNextChange = () => {
    onPageChange(currentPage! + 1);
  };

  const handlePagePreviousChange = () => {
    onPageChange(currentPage! - 1);
  };

  const GetPageBtns = () => {
    const pageBtns = [];

    for (let idx = 1; idx <= pagesSize; idx++) {
      const btn = (
        <Button
          onClick={() => handlePageChange(idx)}
          key={idx}
          className={'page-btn'}
          variant={idx === currentPage ? 'primary' : 'primary-outline'}
        >
          {idx}
        </Button>
      );

      pageBtns.push(btn);
    }

    return pageBtns;
  };

  return (
    <div className={'pager d-flex px-0'}>
      <Button
        onClick={handlePagePreviousChange}
        className={'previous-btn'}
        variant={'primary-outline'}
        disabled={currentPage === 1}
      >
        Previous
      </Button>

      <div>{GetPageBtns()}</div>

      <Button
        onClick={handlePageNextChange}
        className={'next-btn'}
        variant={'primary-outline'}
        disabled={currentPage === pagesSize}
      >
        Next
      </Button>
    </div>
  );
};

export default Pager;
